import service from "./utils/request";

const List = {
    505:{
        message:"您的证书已失效,请重新登录!",
        type:"warning",
        do:"relogin"
    },
    501:{
        message:"您的账号不存在或密码不正确",
        type:"warning",
        do:null
    },
    502:{
        message:"您的密码错误,请查看",
        type:"warning",
        do:null
    },
    403:{
        message:"您当前没有此操作的权限",
        type:"warning",
        do:null
    },
    "other":{
        message:"发生不知名错误,请查看控制台",
        type:"warning",
        do:null
    }
};

export default List
